import { owcTheme } from 'core/theme/theme.config';
import styled from 'styled-components';

export const EapSettingsFormHeaderStyled = styled.div`
    width: 100%;
    padding: 32px;
    background-color: #fff;
    border-bottom: 1px solid ${owcTheme['one-color-background-contrast']};

    > .title {
        display: flex;
        flex-direction: column;
        gap: 4px;
        height: 60px;

        owc-typography[variant='body1'] {
            color: ${owcTheme['one-color-interaction-disabled-base']};
        }
    }
`;
